import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../shared/shared.module';

import { StepperComponent } from './stepper/stepper.component';
import { SummaryComponent } from './summary/summary.component';
import { PopularDishesComponent } from './popular-dishes/popular-dishes.component';


@NgModule({
  imports: [
    SharedModule,
    IonicModule,
    RouterModule
  ],
  declarations: [
    StepperComponent,
    SummaryComponent,
    PopularDishesComponent
  ], 
  exports: [
    StepperComponent,
    SummaryComponent,
    PopularDishesComponent
  ]
})
export class ShopDetailSharedModule {}